module.exports = __webpack_public_path__ + "static/media/cw.ca8caf27.PNG";